module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq345-23e1138c35b8e92ceefe9a97b9bf2051.jpg";